// Classes.
import { BaseLocator } from './../locators/base.locator';



export class CompetitionDisciplinesLocator extends BaseLocator {

    constructor() {
        super('competitionDisciplinesList');
    }
}

